import {itControlApproachType} from '../../../../../../../util/uiconstants';

export function getItProcessApplicationCount(itProcess, relatedItApplications) {
	let relatedItAppCount = 0;
	if (itProcess?.itApplications && itProcess.itApplications.length > 0) {
		itProcess.itApplications.forEach((itAppId) => {
			const itApp = relatedItApplications[itAppId];
			if (!itApp?.isServiceOrganization) {
				relatedItAppCount++;
			}
		});
	}
	return relatedItAppCount;
}

export function getRelatedITControls(allItControls, relatedItControls, hasITControlTesting) {
	return allItControls?.filter(
		(itControl) =>
			relatedItControls?.includes(itControl.id) &&
			(hasITControlTesting === undefined || itControl.hasITControlTesting === hasITControlTesting)
	);
}

export function getRelatedItGcsList(relatedITControls) {
	const result = relatedITControls.filter((ic) => ic.itApproachTypeId === itControlApproachType.controls);
	return result;
}

export function getRelatedItGcCount(relatedItGcsList) {
	const relatedItGcs = {};
	relatedItGcsList.forEach((itControl) => {
		if (!relatedItGcs[itControl.id]) {
			relatedItGcs[itControl.id] = true;
		}
	});
	const relatedItGcCount = Object.keys(relatedItGcs).length;
	return relatedItGcCount;
}

export function getRelatedItRiskCount(itRisks) {
	return itRisks && itRisks.length > 0 ? itRisks.length : 0;
}

export function getItProcessControlCount(itProcess, allControls, filteredControlIds, hasControlTesting, controlTypeId) {
	let controlsCount = 0;
	if (itProcess?.controls?.length > 0) {
		filteredControlIds.forEach((controlId) => {
			const control = allControls.byId[controlId];

			if (
				control &&
				control.controlTypeId === controlTypeId &&
				(hasControlTesting === undefined || control.hasControlTesting === hasControlTesting)
			) {
				controlsCount++;
			}
		});
	}
	return controlsCount;
}
